const getImage = (id) => (
  `https://i.giphy.com/media/${id}/giphy.webp`
);

export default getImage;
